import { atom } from 'jotai';
import type { DealDocDTO } from '../../../services/queries/DealDocQueries';

export const selectedCompanyIdState = atom<number | null>(null);

export const selectedDocumentState = atom<DealDocDTO | null>(null);

export const selectedActionState = atom<'reassign' | null>(null);

export const invalidateDataState = atom<number>(0);
